import React from 'react';

/** Rolling window labels (aligned with stream/project card-stats `timeframe`). */
export const ACTIVITY_WINDOW_LABEL = {
  week: 'Last 7 days',
  month: 'Last 30 days',
  year: 'Last 365 days',
};

/** Body section below card header — matches list borders, slightly thicker top rule. */
export const ACTIVITY_CARD_BODY_CLASS =
  'border-t-2 border-dark-border px-5 pb-5 pt-3 flex flex-col gap-4 flex-1 min-h-0';

/**
 * Week / month / year rolling window (matches card-stats API `timeframe` query).
 */
export function PeriodSelect({ id, value, onChange, disabled }: any) {
  return (
    <div className="shrink-0">
      <label htmlFor={id} className="sr-only">
        Activity period (week, month, or year)
      </label>
      <select
        id={id}
        className="inline-block w-auto min-w-[4.5rem] max-w-[6rem] shrink-0 rounded-md border border-dark-border bg-dark-surface py-1 pl-2 pr-7 text-xs font-medium leading-normal text-slate-100 shadow-sm focus:border-vivid-red focus:ring-2 focus:ring-vivid-red focus:ring-opacity-50 focus:outline-none transition-colors duration-200 disabled:cursor-not-allowed disabled:opacity-50 [&>option]:text-xs"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      >
        <option value="week">Week</option>
        <option value="month">Month</option>
        <option value="year">Year</option>
      </select>
    </div>
  );
}

export function ActivityStat({ icon: Icon, iconClass, value, label, title }: any) {
  return (
    <div
      className="flex min-w-0 flex-col items-center rounded-xl border border-dark-border bg-dark-surface/40 px-2.5 py-2.5 text-center"
      title={title}
    >
      <Icon className={`w-4 h-4 shrink-0 mb-1 ${iconClass}`} aria-hidden />
      <span className="text-lg font-semibold tabular-nums text-slate-100 leading-none tracking-tight">
        {value}
      </span>
      <span className="text-[11px] font-medium text-slate-400 mt-1 leading-tight">{label}</span>
    </div>
  );
}
